<div class="h-full w-full surface-50 p-2">
  <p-card class="policy-component block shadow-3">
    <ng-template pTemplate="header">
      <div class="flex p-3 gap-2 align-items-center">
        <h3 class="mr-3">{{pageTitle}}</h3>
        <p-button [rounded]="true" class="ml-auto" (click)="edit()">
          Create
        </p-button>
      </div>
    </ng-template>
    <div class="p-0">
      <p-table
        styleClass="risk-table-striped"
        [value]="incidentResponses"
        *ngIf="incidentResponses"
        dataKey="incidentResponseId"
        #incidentResponseTbl
        [tableStyle]="{ 'width': '100%' }"
        [columns]="cols"
      >
        <ng-template pTemplate="caption">
          <div class="flex">
            <p-button
              icon="pi pi-file-excel"
              (click)="incidentResponseTbl.exportCSV()"
              [outlined]="true"
              severity="secondary"
              class="ml-auto"
            ></p-button>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem"></th>
            <th
              class="font-bold white-space-nowrap"
              pSortableColumn="incidentResponseNumber"
            >
              Incident ID
              <p-sortIcon
                class="sort-icon"
                field="incidentResponseNumber"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th
              class="font-bold white-space-nowrap"
              pSortableColumn="name"
            >
              Name
              <p-sortIcon
                class="sort-icon"
                field="name"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th class="font-bold white-space-nowrap" pSortableColumn="type">
              Type
              <p-sortIcon
                class="sort-icon"
                field="type"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th
              class="font-bold white-space-nowrap"
              pSortableColumn="occuredDate"
            >
              Date
              <p-sortIcon
                class="sort-icon"
                field="occuredDate"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th
              class="font-bold white-space-nowrap"
              pSortableColumn="severityLevel"
            >
              Severity
              <p-sortIcon
                class="sort-icon"
                field="severityLevel"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th
              class="font-bold white-space-nowrap"
              pSortableColumn="lastUpdated"
            >
              Updated
              <p-sortIcon
                class="sort-icon"
                field="lastUpdated"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-expanded="expanded">
          <tr [pReorderableRow]="i">
            <td>
              <button
                type="button"
                pButton
                pRipple
                [pRowToggler]="item"
                class="p-button-text p-button-rounded p-button-plain"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
              ></button>
            </td>
            <td>
              {{ item.incidentResponseNumber }}
            </td>
            <td>
              {{ item.name }}
            </td>
            <td>{{ item.type }}</td>
            <td>{{ item.occuredDate | date : 'shortDate' }}</td>
            <td>{{ item.severityLevel }}</td>
            <td>{{ item.lastUpdated | date : 'M/d/yyyy h:mma z' }}</td>
            <td>
              <div class="flex align-items-center justify-content-center gap-1">
                <p-button
                  [text]="true"
                  icon="pi pi-pencil"
                  (click)="edit(item)"
                ></p-button>
                <p-button
                  [text]="true"
                  icon="pi pi-trash"
                  severity="danger"
                  mwlConfirmationPopover
                  [title]="'Delete Incident Response'"
                  [popoverMessage]="
                    'You are going to delete this policy. Are you sure?'
                  "
                  [appendToBody]="true"
                  [confirmText]="'Yes'"
                  [cancelText]="'No'"
                  placement="left"
                  (confirm)="dropIncidentResponse(item)"
                ></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="expandedrow" let-item>
          <tr>
            <td colspan="8" class="text-sm">
              <div class="grid">
                <div class="col">
                  <span class="font-semibold">Incident #:</span>
                  {{ item.incidentResponseNumber }}
                </div>
                <div class="col">
                  <span class="font-semibold">Name:</span>
                  {{ item.name }}
                </div>
              </div>
              <div class="grid">
                <div class="col">
                  <span class="font-semibold">Type of Incident:</span>
                  {{ item.type }}
                </div>
              </div>
              <div class="grid">
                <div class="col">
                  <span class="font-semibold">Date Occured:</span>
                  {{ item.occuredDate | date : 'shortDate' }}
                </div>
                <div class="col">
                  <span class="font-semibold">Reported Date:</span>
                  {{ item.reportedDate | date : 'shortDate' }}
                </div>
              </div>
              <div class="grid">
                <div class="col">
                  <span class="font-semibold">Severity Level:</span>
                  {{ item.severityLevel }}
                </div>
                <div class="col">
                  <span class="font-semibold">Reported By:</span>
                  {{ item.reportedBy }}
                </div>
              </div>
              <div class="grid">
                <div class="col">
                  <span class="font-semibold"
                    >Systems & Services Impacted:</span
                  >
                  {{ item.systemsAndServicesImpacted }}
                </div>
                <div class="col">
                  <div *ngIf="item.approved1Date"><span class="font-semibold">Approved by: </span> {{item.approver1Id}} on {{item.approved1Date | date: 'shortDate'}} {{item.approved1Date | date: 'shortTime'}}</div>
                  <div *ngIf="item.approved2Date"><span class="font-semibold">Approved by: </span> {{item.approver2Id}} on {{item.approved2Date | date: 'shortDate'}} {{item.approved2Date | date: 'shortTime'}}</div>
                </div>
              </div>
              <div class="grid">
                <div class="col">
                  <span class="font-semibold">Initial Reporting</span>
                  <div
                    class="ql-editor"
                    [innerHTML]="addToken(item.initialReporting) | sanitizeHtml"
                  ></div>
                </div>
                <div class="col">
                  <span class="font-semibold">Incident Sequence of Events</span>
                  <div
                    class="ql-editor"
                    [innerHTML]="
                      addToken(item.incidentSequenceOfEvents) | sanitizeHtml
                    "
                  ></div>
                </div>
              </div>
              <div class="grid">
                <div class="col">
                  <span class="font-semibold">Incident Mitigation</span>
                  <div
                    class="ql-editor"
                    [innerHTML]="
                      addToken(item.incidentMitigation) | sanitizeHtml
                    "
                  ></div>
                </div>
                <div class="col">
                  <span class="font-semibold">Documentation</span>
                  <div
                    class="ql-editor"
                    [innerHTML]="addToken(item.documentation) | sanitizeHtml"
                  ></div>
                </div>
              </div>
              <div class="grid">
                <div class="col">
                  <span class="font-semibold">Recommendations</span>
                  <div
                    class="ql-editor"
                    [innerHTML]="addToken(item.recommendations) | sanitizeHtml"
                  ></div>
                </div>
                <div class="col">
                  <span class="font-semibold">Additional Comments/Notes</span>
                  <div
                    class="ql-editor"
                    [innerHTML]="
                      addToken(item.additionalCommentsNotes) | sanitizeHtml
                    "
                  ></div>
                </div>
              </div>
              <div class="grid">
                <div class="col">
                  <span class="font-semibold">Attachments</span>
                  <p-table
                    *ngIf="item.attachments"
                    [value]="item.attachments"
                    #table
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th
                          class="font-bold white-space-nowrap"
                          *ngFor="let col of attachmentCols"
                          [pSortableColumn]="col.field"
                          [ngStyle]="{ 'width': col.width || 'auto' }"
                        >
                          {{ col.header }}
                        </th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-file>
                      <tr [pSelectableRow]="file">
                        <td>
                          {{ file.date | date : 'shortDate' }} by
                          {{ file.submitterName }}
                        </td>
                        <td>
                          <span
                            (click)="DownloadAttachment(file.internalName)"
                            class="btn btn-link"
                            >{{ file.name }}</span
                          >
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-card>
</div>
